import Immutable from 'immutable';

class InlineRefund extends waffle.base.BaseComponent {
  render() {
    const transaction = this.props.transaction;

    return (
      <div className="alert alert-secondary">
        <a className="alert-link" href={"/transactions/" + transaction.get('uuid')}>
          {transaction.get('paymentType').titleize()} {transaction.get('displayAmount')}
        </a> ({transaction.get('transactionState').titleize()})<br />
        Refunded at: {moment(transaction.get('created')).format('YYYY/MM/DD HH:mm:ss')}<br />
        Note: {transaction.getIn(['details', 'note'])}
      </div>
    );
  }
}

class InlineRefunds extends waffle.base.BaseComponent {
  constructor() {
    super();
    this.state = {};
  }

  componentWillMount() {
    this.fetchRefunds();
  }

  fetchRefunds() {
    $.ajax({
      url: `/api/transactions/${this.props.uuid}/associated`,
      dataType: 'json',
      type: 'GET'
    }).done((response) => {
      if (response.status == 200) {
        this.setState({
          refundTransactions: Immutable.fromJS(response.data.transactions),
          errorMessage: null
        });
      } else {
        this.setState({
          errorMessage: response.message ? response.message : "Unknown error"
        });
      }
    }).fail((unused, textStatus) => {
      this.setState({
        errorMessage: textStatus
      });
    })
  }

  render() {
    if (this.state.refundTransactions) {
      return (
        <div className="inline-exceptions">
          {
            this.state.refundTransactions.map((refundTransaction) => {
              return (
                <InlineRefund
                  transaction={refundTransaction} key={refundTransaction.get('uuid')}
                />
              )
            })
          }
        </div>
      );
    } else if (this.state.errorMessage) {
      return (
        <div className="alert alert-danger inline-exception">
          Unable to load list of refunds: {this.state.errorMessage}
        </div>
      );
    }

    return <div></div>
  }
}

module.exports = {
  InlineRefunds
}
